module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg20.66131558.jpg";